import { Suspense, lazy } from "react";
import { Navigate } from "react-router-dom";
import { RouteObject } from "react-router";
import SuspenseLoader from "src/components/SuspenseLoader";
import FlightLayout from "./layouts/FlightLayout";
import BaseLayout from "./layouts/BaseLayout";

// Lazy imports
const Home = lazy(() => import("src/views/home"));
const AboutUs = lazy(() => import("src/views/aboutUs"));
const ContactUs = lazy(() => import("src/views/contactUs"));
const Blogs = lazy(() => import("src/views/blogs"));
const BlogDetail = lazy(() => import("src/views/blogs/detail"));
const FlightsList = lazy(() => import("src/views/flightsList"));
const Vacations = lazy(() => import("src/views/popularVacations"));
const VacationDetail = lazy(
  () => import("src/views/popularVacations/Vacations/detail")
);
const BookingSuccess = lazy(() => import("src/views/bookingSuccess"));
const BookingRules = lazy(() => import("src/views/bookingRules"));
const PrivacyPolicy = lazy(() => import("src/views/privacyPolicy"));
const Booking = lazy(() => import("src/views/booking"));

const Loader = (Component: any) => (props: any) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Wrapped, TS-safe components
const HomePage = Loader(Home);
const AboutUsPage = Loader(AboutUs);
const ContactUsPage = Loader(ContactUs);
const BlogsPage = Loader(Blogs);
const BlogDetailPage = Loader(BlogDetail);
const FlightsListPage = Loader(FlightsList);
const VacationsPage = Loader(Vacations);
const VacationDetailPage = Loader(VacationDetail);
const BookingSuccessPage = Loader(BookingSuccess);
const BookingRulesPage = Loader(BookingRules);
const PrivacyPolicyPage = Loader(PrivacyPolicy);
const BookingPage = Loader(Booking);

const routes = (role?: string, isLoggedIn: boolean = false): RouteObject[] => [
  {
    path: "",
    element: <FlightLayout />,
    children: [
      { path: "*", element: <Navigate to="" replace /> },
      { path: "", element: <HomePage /> },
      { path: "flights", element: <FlightsListPage /> },
    ],
  },
  {
    path: "",
    element: <BaseLayout />,
    children: [
      { path: "*", element: <Navigate to="" replace /> },

      { path: "vacations", element: <VacationsPage /> },
      { path: "success", element: <BookingSuccessPage /> },
      { path: "vacations/:id", element: <VacationDetailPage /> },

      { path: "flight-booking-success", element: <BookingSuccessPage /> },

      { path: "blog", element: <BlogsPage /> },
      { path: "blog/article/:id", element: <BlogDetailPage /> },

      { path: "about-us", element: <AboutUsPage /> },
      { path: "booking", element: <BookingPage /> },
      { path: "contact-us", element: <ContactUsPage /> },

      { path: "terms", element: <BookingRulesPage /> },
      { path: "privacy-policy", element: <PrivacyPolicyPage /> },
    ],
  },
];

export default routes;
